import React from "react";
import "./FormField.css";

/**
 * Label + control + hint + inline error, wired together for accessibility
 * (label htmlFor/id, aria-invalid, aria-describedby).
 *
 * as: "input" (default) | "select" | "textarea". Extra props go to the control;
 * for "select", pass the <option>s as children.
 */
const FormField = ({
  id,
  label,
  required = false,
  error,
  hint,
  as: Control = "input",
  span = false,
  children,
  ...controlProps
}) => {
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(" ") || undefined;

  return (
    <div className={`ahd-field${span ? " ahd-field--span" : ""}`}>
      <label htmlFor={id} className="ahd-field__label">
        {label}
        {required && (
          <span className="ahd-field__required" aria-hidden="true">
            {" "}
            *
          </span>
        )}
      </label>
      <Control
        id={id}
        className={`ahd-field__control${error ? " ahd-field__control--error" : ""}`}
        aria-required={required || undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        {...controlProps}
      >
        {children}
      </Control>
      {hint && (
        <p id={hintId} className="ahd-field__hint">
          {hint}
        </p>
      )}
      {error && (
        <p id={errorId} className="ahd-field__error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default FormField;
